import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { SelectingType } from "./zonesSlice";

export type Type = "personal" | "linear" | "taxi_company" | "online_taxi";

interface IState {
  visible: boolean;
  waybillShowType: number;
  markerMode: SelectingType[];
  heatmapMode: SelectingType;
  pointwiseShow: boolean;
  loading: boolean;
  waybillTypes: any[];
}

const initialState: IState = {
  visible: false,
  waybillShowType: 0,
  markerMode: ["source"],
  heatmapMode: "source",
  pointwiseShow: false,
  loading: false,
  waybillTypes: [],
};

export const waybillSlice = createSlice({
  name: "waybill",
  initialState,
  reducers: {
    changeWaybillShowType: (state, action: PayloadAction<number>) => {
      return { ...state, waybillShowType: action.payload };
    },
    toggleVisibility: (state) => {
      return { ...state, visible: !state.visible };
    },
    makeInvisible: (state) => {
      return { ...state, visible: false };
    },
    changeMarkerMode: (state, action: PayloadAction<SelectingType[]>) => {
      return { ...state, markerMode: action.payload };
    },
    changeHeatMapMode: (state, action: PayloadAction<SelectingType>) => {
      return { ...state, heatmapMode: action.payload };
    },
    togglePointwiseShow: (state) => {
      return { ...state, pointwiseShow: !state.pointwiseShow };
    },
    changeLoadingMode: (state, action: PayloadAction<boolean>) => {
      return { ...state, loading: action.payload };
    },
    // changeType: (state, action: PayloadAction<Type>) => {
    //   return { ...state, type: action.payload };
    // },
    changeWaybillType: (state, action: PayloadAction<any>) => {
      if (state.waybillTypes.includes(action.payload)) {
        return { ...state, waybillTypes: state.waybillTypes.filter((c) => c !== action.payload) };
      }
      return { ...state, waybillTypes: [...state.waybillTypes, action.payload] };
    },
  },
});

export const {
  changeWaybillShowType,
  toggleVisibility,
  makeInvisible,
  changeMarkerMode,
  changeHeatMapMode,
  togglePointwiseShow,
  changeLoadingMode,
  changeWaybillType,
} = waybillSlice.actions;

export default waybillSlice.reducer;
